import React from 'react';
import './App.css';
import Header from './components/Header/Header';
import Hero from './components/Hero/Hero';
import About from './components/About/About';
import CarShowcase from './components/CarShowcase/CarShowcase';
import BrandShowcase from './components/BrandShowcase/BrandShowcase';
import CustomerService from './components/CustomerService/CustomerService';
import Footer from './components/Footer/Footer';

function App() {
  return (
    <div className="app">
      <Header />
      <main>
        <Hero />
        <About />
        <CarShowcase />
        <BrandShowcase />
        <CustomerService />
      </main>
      <Footer />
    </div>
  );
}

export default App;
